import type {
  DeleteDocumentAttachmentRequestType,
  DeleteDocumentAttachmentResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const deleteDocumentAttachment = async (
  params: DeleteDocumentAttachmentRequestType,
) => {
  const { documentId, attachmentId } = params;
  const url = `/api/v2/documents/${documentId}/attachments/${attachmentId}`;
  await apiAuthClient.delete<DeleteDocumentAttachmentResponseType>(url);
};
